import { render } from "./ReserveDetailText.vue?vue&type=template&id=de8d2e56"
import script from "./ReserveDetailText.vue?vue&type=script&lang=js"
export * from "./ReserveDetailText.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ReserveDetailText.vue?vue&type=style&index=0&id=de8d2e56&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__